import { createContext, useState } from 'react';

const FavoritesContext = createContext({
    favorites: [],
    totalFavorites: 0,
    addFavorite: (favoriteNote) => {},
    removeFavorite: (noteId) => {},
    itemIsFavorite: (noteId) => {}
});

export function FavoritesContextProvider(props) {
    const [userFavorites, setUserFavorites] = useState([]);

    function addFavoriteHandler(favoriteNote) {
        setUserFavorites((preUserFavorites) => {
            return preUserFavorites.concat(favoriteNote);
        });  
    }

    function removeFavoriteHandler(noteId) {
        setUserFavorites(preUserFavorites => {
            return preUserFavorites.filter(note => note.id !== noteId);
        });  
    }

    function itemIsFavoriteHandler(noteId) {
        return userFavorites.some(note => note.id === noteId);
    }

    const context = {
        favorites: userFavorites,
        totalFavorites: userFavorites.length,
        addFavorite: addFavoriteHandler,
        removeFavorite: removeFavoriteHandler,
        itemIsFavorite: itemIsFavoriteHandler

    };

    return (
        <FavoritesContext.Provider value={context}>
          {props.children}  
        </FavoritesContext.Provider>
    );
}

export default FavoritesContext;
